import { cn } from "../../../lib/cn";
import { useStage } from "./context";

/**
 * Dot navigation down the right edge: one dot per scene, the current one
 * stretched into a pill. Labels slide out on hover/focus. Only from xl up,
 * where the page margin can hold it without covering content; below that the
 * wheel, keys and thumb are the pager.
 */
export function Pager() {
  const { scenes, arrivedId, goTo } = useStage();
  const dark = scenes.find((s) => s.id === arrivedId)?.tone === "dark";

  return (
    <nav aria-label="Page sections" className="fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 xl:block">
      <ul className="flex flex-col items-end gap-2">
        {scenes.map((s) => {
          const current = s.id === arrivedId;
          return (
            <li key={s.id}>
              <button
                type="button"
                onClick={() => goTo(s.id)}
                aria-label={s.label}
                aria-current={current ? "true" : undefined}
                className="group flex h-6 items-center gap-3 rounded-full outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2"
              >
                <span
                  aria-hidden="true"
                  className={cn(
                    "pointer-events-none translate-x-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium opacity-0 shadow-soft transition duration-200 group-hover:translate-x-0 group-hover:opacity-100 group-focus-visible:translate-x-0 group-focus-visible:opacity-100",
                    dark ? "bg-white/15 text-white backdrop-blur" : "bg-white text-neutral-700",
                  )}
                >
                  {s.label}
                </span>
                <span
                  aria-hidden="true"
                  className={cn(
                    "block h-2 rounded-full transition-all duration-300",
                    current ? "w-6" : "w-2",
                    current
                      ? dark
                        ? "bg-white"
                        : "bg-gradient-to-r from-sky-500 to-indigo-500"
                      : dark
                        ? "bg-white/35 group-hover:bg-white/70"
                        : "bg-neutral-300 group-hover:bg-neutral-400",
                  )}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
